/**
 * Paleta de colores predefinidos para las parejas
 * Cada color ha sido seleccionado para garantizar buen contraste con fondos de toast y marcadores
 */

export const TEAM_COLOR_PALETTE = [
  {
    id: 'blue',
    name: 'Azul',
    hex: '#667eea',
    category: 'vibrant',
    isDefault: true, // Color por defecto pareja 1
  },
  {
    id: 'red',
    name: 'Rojo',
    hex: '#f5576c',
    category: 'vibrant',
    isDefault: true, // Color por defecto pareja 2
  },
  {
    id: 'green',
    name: 'Verde',
    hex: '#4caf50',
    category: 'vibrant',
  },
  {
    id: 'purple',
    name: 'Morado',
    hex: '#9c27b0',
    category: 'vibrant',
  },
  {
    id: 'indigo',
    name: 'Índigo',
    hex: '#3f51b5',
    category: 'vibrant',
  },
  {
    id: 'teal',
    name: 'Turquesa',
    hex: '#26a69a',
    category: 'pastel',
  },
  {
    id: 'cyan',
    name: 'Cian',
    hex: '#00bcd4',
    category: 'vibrant',
  },
  {
    id: 'pink',
    name: 'Rosa',
    hex: '#e91e63',
    category: 'vibrant',
  },
];

/**
 * Obtiene un color de la paleta por su ID
 */
export const getColorById = (id) => {
  return TEAM_COLOR_PALETTE.find(color => color.id === id);
};

/**
 * Obtiene un color de la paleta por su valor hexadecimal
 */
export const getColorByHex = (hex) => {
  return TEAM_COLOR_PALETTE.find(color => color.hex.toLowerCase() === hex.toLowerCase());
};

/**
 * Obtiene los colores por defecto para cada pareja
 */
export const getDefaultColors = () => {
  const defaults = TEAM_COLOR_PALETTE.filter(color => color.isDefault);
  return {
    team1: defaults[0],
    team2: defaults[1],
  };
};
